<template>
  <div class="card tarjeta">
    <div class="fondo-tarjeta pointer" @click="goToDetalleAgrupacion">
      <template v-if="agrupacion.imagenDesktop">
        <img class="img-tarjeta" :src="agrupacion.imagenDesktop" alt="" />
      </template>
      <template v-else>
        <div class="img-tarjeta" src="../../assets/fotos/est1.webp" alt="" />
      </template>
      <div class="card-body seccion-inferior-tarjeta ps-0 pointer" @click="goToDetalleAgrupacion">
        <div class="titulo">
          {{ agrupacion.titulo }}
        </div>
        <div class="descripcion">
          {{ showOnlyTwoLines(agrupacion.descripcion) }}
        </div>
        <div class="saber-mas text-primary" @click="goToDetalleAgrupacion">
          {{ $t('general.quieroSaberMas') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { useRouter } from 'vue-router';
  import { showOnlyTwoLines } from '@/helpers/filters';
  import { AgrupacionDetalle } from '@/router/RouterNames';

  const props = defineProps({
    agrupacion: {
      type: Object,
      default: null,
    },
  });
  const router = useRouter();

  function goToDetalleAgrupacion() {
    router.push({
      name: AgrupacionDetalle,
      params: {
        uri: props.agrupacion.uri,
      },
    });
  }
</script>

<style lang="css" scoped>
  .tarjeta {
    background-color: transparent;
    width: 95%;
    height: 95%;
    border: 0px !important;
  }

  .fondo-tarjeta {
    border-radius: var(--bs-border-radius-xl);
    height: 100%;
    background-position: center;
    background-size: cover;
    object-position: center;
    object-fit: cover;
  }

  .seccion-inferior-tarjeta {
    background-color: white;
    bottom: 0;
    height: 20%;
    width: 100%;
  }

  .titulo {
    color: var(--bs-primary);
    text-align: start;
    font-size: 1.2rem;
    font-weight: 700;
  }

  .descripcion {
    color: var(--bs-primary);
    text-align: start;
    font-size: 0.8rem;
    font-weight: 500;
  }

  .img-tarjeta {
    background-size: cover;
    background-position: center;
    border-radius: var(--bs-border-radius-xxl);
    width: 100%;
    height: 250px;
    object-position: center;
    object-fit: cover;
  }

  .saber-mas {
    font-weight: 600;
    margin-top: 1rem;
    text-align: start;
    color: var(--bs-primary);
    cursor: pointer;
    text-decoration: underline;
  }

  .saber-mas:hover {
    text-decoration: underline;
  }

  @media (max-width: 575px) {
    .img-tarjeta {
      margin: auto;
    }

    .seccion-inferior-tarjeta {
      margin: auto;
      width: 100%;
    }
  }
</style>
